export function generaArrayDateNuovoFinoAl() {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth(); // 0-based, so 0 is January and 11 is December

  const dates = [];

  // Helper function to format the date
  function formatDate(day, month, year) {
    return `${day.toString().padStart(2, "0")}${(month + 1)
      .toString()
      .padStart(2, "0")}${year}`;
  }

  // Determine the next 31st of March or 31st of August
  let nextYear = currentYear;
  let nextDate;

  if (currentMonth <= 2) {
    // January, February, March
    nextDate = formatDate(31, 2, currentYear); // 31 March of current year
  } else if (currentMonth <= 7) {
    // April, May, June, July, August
    nextDate = formatDate(31, 7, currentYear); // 31 August of current year
  } else {
    // September, October, November, December
    nextDate = formatDate(31, 2, currentYear + 1); // 31 March of next year
    nextYear++;
  }

  dates.push(nextDate);

  // Add the following two dates
  for (let i = 1; i < 3; i++) {
    nextDate = nextDate.includes("08")
      ? formatDate(31, 2, nextYear + i)
      : formatDate(31, 7, nextYear + i - 1);
    dates.push(nextDate);
  }

  return dates;
}

export function formatDataPerTasto(numero) {
  let numStr = numero.toString();

  // Verifica che il numero sia lungo 8 caratteri
  if (numStr.length !== 8) {
    return "Errore: Il numero deve avere esattamente 8 cifre";
  }

  // Formatta la stringa in formato 00/00/0000
  let giorno = numStr.substring(0, 2);
  let mese = numStr.substring(2, 4);
  let anno = numStr.substring(4, 8);

  return `${giorno}/${mese}/${anno}`;
}
